import commonEnvironment from 'config/nl/common-environment';
import paypal from 'config/paypal';
import { ShopEnvironment } from 'config/types';

export default {
  ...commonEnvironment,
  apiEndpoint: 'https://api.petsdeli.nl',
  backInStockUrl: 'https://jzk1.myshopify.com', // TODO: NL Shopify store?
  contentfulEnv: 'master',
  pdexEndpoint: 'https://merchant.petsdeli.nl',
  foodaidEndpoint: 'https://api.petsdeli.de/fube-live-2023-04',
  ninetailedEnv: 'main',
  oosEndpoint: 'https://api.oos.petsdeli.de',
  paypalClientId: paypal.production,
  shopifyUrl: 'https://shop.petsdeli.nl',
  midaKey: 'nvmGW7eJdkWL9dw81xXQKA', // TODO: NL Mida key, or drop it? (CH has none)
  gtmScriptUrl: 'https://sst.petsdeli.nl/g27fwnhmpv.js?tg=NK69QT6',
  gtmNoScriptUrl: 'https://sst.petsdeli.nl/g27fwnhmpv.html?tg=NK69QT6',
} satisfies ShopEnvironment;
